import SlideManager from 'slidemanager'
import Block from './Block'
import { Expo } from 'gsap/EasePack'
import TweenMax, { TimelineLite } from 'gsap/TweenMax'

export default class SolutionsSlider extends Block {
  constructor(el, destroyLast) {
    super(el, destroyLast)

    this.el = el
    this.destroyLast = destroyLast

    this.splitContent(this.slideContents)
    this.createSlider()
    this.initSlider()
  }

  bindMethods() {
    super.bindMethods()

    this.prevSlide = this.prevSlide.bind(this)
    this.nextSlide = this.nextSlide.bind(this)
    this.hideOldSlide = this.hideOldSlide.bind(this)
    this.showNewSlide = this.showNewSlide.bind(this)
  }

  getElems() {
    super.getElems()

    this.slideWrapper = this.el.querySelector('.slide-wrapper')
    this.items = this.el.querySelectorAll('.item')
    this.pagerLeft = this.el.querySelector('.pager-left')
    this.pagerRight = this.el.querySelector('.pager-right')
    this.slideContents = this.el.querySelectorAll('.solutions__slider-item--content')
    this.cta = this.el.querySelector('.cta')
  }

  events() {
    super.events()

    this.pagerLeft.addEventListener('click', this.prevSlide)
    this.pagerRight.addEventListener('click', this.nextSlide)
  }

  splitContent(content) {
    if (!content) return

    for (let i = 0; i < content.length; i++) {
      this.splittedContent = new SplitText(content[i], {
        type: 'lines',
        linesClass: 'line'
      })
      this.wrap()
    }
  }

  wrap() {
    for (let i = 0; i < this.splittedContent.lines.length; i++) {
      const inner = this.splittedContent.lines[i].innerHTML

      this.splittedContent.lines[i].innerHTML = '<span>' + inner + '</span>'
    }

    // window.setTimeout(() => {
    //   this.initSlider()
    // }, 2000)
  }

  createSlider() {
    this.slider = new SlideManager({
      el: this.slideWrapper,
      loop: true,
      callback: (event) => {
        this.oldIndex = event.previous
        this.currentIndex = event.current
        this.direction = event.direction

        this.hideOldSlide()
          .then(this.showNewSlide)
          .then(() => {
            this.slider.done()
          })
      }
    })
  }

  initSlider() {
    for (let i = 0; i < this.items.length; i++) this.items[i].style.display = 'none'
    this.items[0].style.display = 'block'
    this.cta.href = this.items[0].dataset.href
  }

  hideOldSlide() {
    return new Promise((resolve) => {
      const lines = this.items[this.oldIndex].querySelectorAll('.line > span')
      const title = this.items[this.oldIndex].querySelector('.heading__full')

      const tl = new TimelineLite({
        onComplete: () => {
          resolve()
          this.items[this.oldIndex].style.display = 'none'
          this.items[this.currentIndex].style.display = 'block'
          TweenMax.set(lines, { y: '100%' })
          TweenMax.set(title, { y: '100%' })
        }
      })

      tl.addLabel('start', 0)

      tl.staggerTo(lines, 1, {
        y: '-100%',
        ease: Expo.easeInOut
      }, 0.05, 'start')
      tl.to(title, 1, {
        y: '-100%',
        ease: Expo.easeInOut
      }, 'start')
    })
  }

  showNewSlide() {
    return new Promise((resolve) => {
      const lines = this.items[this.currentIndex].querySelectorAll('.line > span')
      const title = this.items[this.currentIndex].querySelector('.heading__full')

      this.cta.href = this.items[this.currentIndex].dataset.href

      const tl = new TimelineLite({
        onComplete: () => {
          resolve()
        }
      })

      tl.addLabel('start', 0)

      tl.staggerTo(lines, 1, {
        y: '0%',
        ease: Expo.easeOut
      }, 0.05, 'start')
      tl.to(title, 1, {
        y: '0%',
        ease: Expo.easeOut
      }, 'start')
    })
  }

  prevSlide() {
    this.slider.prev()
  }

  nextSlide() {
    this.slider.next()
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/SolutionsSlider.js